import React, { useState, useEffect } from 'react';
import { getGalleryItems, fetchGalleryItemsAsync } from '../../services/storage';

const CATEGORIES = [
    { id: 'all', label: 'Tất Cả Ảnh' },
    { id: 'space', label: 'Không Gian Quán' },
    { id: 'coffee', label: 'Cà Phê Phin' },
    { id: 'moments', label: 'Khoảnh Khắc' }
];

const Gallery = () => {
    const [galleryData, setGalleryData] = useState(getGalleryItems());
    const [activeFilter, setActiveFilter] = useState('all');
    const [currentIndex, setCurrentIndex] = useState(null);

    const loadGallery = async () => {
        const data = await fetchGalleryItemsAsync();
        setGalleryData(data);
    };

    useEffect(() => {
        loadGallery();

        const handleUpdate = () => {
            setGalleryData(getGalleryItems());
        };

        window.addEventListener('cafe9_gallery_updated', handleUpdate);
        return () => window.removeEventListener('cafe9_gallery_updated', handleUpdate);
    }, []);

    const filteredImages = activeFilter === 'all'
        ? galleryData
        : galleryData.filter(item => item.category === activeFilter);

    const openLightbox = (index) => {
        setCurrentIndex(index);
    };

    const closeLightbox = () => {
        setCurrentIndex(null);
    };

    const handlePrev = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev > 0 ? prev - 1 : filteredImages.length - 1));
    };

    const handleNext = (e) => {
        e.stopPropagation();
        setCurrentIndex((prev) => (prev < filteredImages.length - 1 ? prev + 1 : 0));
    };

    return (
        <section className="gallery-section" id="gallery">
            <div className="section-header">
                <span className="section-tag">Góc Kỷ Niệm</span>
                <h2>Khoảnh Khắc Tại <span>Café 9</span></h2>
                <p>Nơi lưu giữ nét đẹp văn hoá cà phê sáng bình dị của người dân và du khách tại làng chài Phước Hải</p>
                <div className="header-divider">
                    <i className="fas fa-camera-retro"></i>
                </div>
            </div>

            {/* Filter Buttons */}
            <div className="gallery-filters">
                {CATEGORIES.map(cat => (
                    <button
                        key={cat.id}
                        className={`gallery-filter-btn ${activeFilter === cat.id ? 'active' : ''}`}
                        onClick={() => setActiveFilter(cat.id)}
                    >
                        {cat.label}
                    </button>
                ))}
            </div>

            {/* Gallery Grid */}
            <div className="gallery-grid">
                {filteredImages.map((item, index) => (
                    <div
                        key={item.id}
                        className="gallery-card"
                        onClick={() => openLightbox(index)}
                    >
                        <img
                            src={item.src}
                            alt={item.caption || 'Café 9'}
                            loading="lazy"
                            onError={(e) => {
                                e.target.src = '/images/cafe9/cafeden.JPG';
                            }}
                        />
                        <div className="gallery-overlay">
                            <div className="gallery-overlay-icon">
                                <i className="fas fa-magnifying-glass-plus"></i>
                            </div>
                            <span className="gallery-caption">{item.caption}</span>
                        </div>
                    </div>
                ))}
            </div>

            {/* Enhanced Lightbox Modal */}
            {currentIndex !== null && filteredImages[currentIndex] && (
                <div className="lightbox-modal" onClick={closeLightbox}>
                    <div className="lightbox-wrapper" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox-close-btn" onClick={closeLightbox} aria-label="Đóng ảnh">
                            &times;
                        </button>

                        <button className="lightbox-nav-btn lightbox-prev" onClick={handlePrev} aria-label="Ảnh trước">
                            <i className="fas fa-chevron-left"></i>
                        </button>

                        <img
                            src={filteredImages[currentIndex].src}
                            alt={filteredImages[currentIndex].caption || 'Café 9'}
                            className="lightbox-img"
                            onError={(e) => {
                                e.target.src = '/images/cafe9/cafeden.JPG';
                            }}
                        />

                        <div className="lightbox-caption-bar">
                            {filteredImages[currentIndex].caption}
                        </div>

                        <button className="lightbox-nav-btn lightbox-next" onClick={handleNext} aria-label="Ảnh tiếp">
                            <i className="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Gallery;